import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";
import { useEffect, useState } from "react";
import { sendPixelEvent } from "@/lib/pixelXApp";
import * as Sentry from '@sentry/react';

const StickyMobileCTAB = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCheckout = async () => {
    Sentry.addBreadcrumb({
      category: 'ui',
      message: 'CTA button clicked',
      level: 'info',
      data: {
        component: 'StickyMobileCTAB',
        variant: 'B',
      },
    });
    
    try {
      await sendPixelEvent('AddToCart');
      
      Sentry.addBreadcrumb({
        category: 'navigation',
        message: 'Redirecting to checkout',
        level: 'info',
        data: { url: "https://pxa.receitasem30minutos.com.br/exp/checkout" },
      });
      
      window.location.href = "https://pxa.receitasem30minutos.com.br/exp/checkout";
    } catch (error) {
      Sentry.captureException(error, {
        tags: { action: 'redirect_checkout' },
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur border-t shadow-lg lg:hidden animate-slide-up">
      <Button 
        onClick={handleCheckout}
        size="lg"
        className="w-full bg-gradient-warm hover:shadow-hover transition-all duration-300 text-lg h-14"
      >
        <ShoppingCart className="mr-2 h-5 w-5" />
        Comprar por R$ 29,90
      </Button>
    </div>
  );
};

export default StickyMobileCTAB;
